import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { hook } from '@g4/automation-hooks';
import tracking from '@g4/g4-analytics';

import { Media, Popup, Text, Box } from './Boneyard';
import Markdown from './Markdown';
import PlainExternalLink from './PlainExternalLink';
import GAClickEventTracker from './GAClickEventTracker';

const StyledDisclaimerButton = styled.button`
  color: ${props => props.theme.colors.disclaimer.buttonText};
`;

const propTypes = {
  fontSize: PropTypes.number,
  disclaimerText: PropTypes.string,
  popupWindowContent: PropTypes.string,
  popupWindowTitle: PropTypes.string,
  disclaimerHook: PropTypes.string,
  disclaimerButtonHook: PropTypes.string,
  disclaimerPopupHook: PropTypes.string,
  disclaimerExternalLinkHook: PropTypes.string,
  trackingLabel: PropTypes.string,
  trackingAction: PropTypes.string,
  openExternalWindowTrackingLabel: PropTypes.string,
};

const Disclaimer = ({
  fontSize,
  disclaimerText,
  popupWindowContent,
  popupWindowTitle,
  disclaimerHook,
  disclaimerButtonHook,
  disclaimerPopupHook,
  disclaimerExternalLinkHook,
  trackingLabel,
  trackingAction,
  openExternalWindowTrackingLabel,
}) => {
  const [showTerms, setShowTerms] = useState(false);
  const urlOrigin = new URL(window.location.href).origin;
  const DisclaimerButton = ({ children }) => {
    return (
      <GAClickEventTracker
        onClick={() => {
          if (!showTerms && trackingLabel) {
            tracking.trackEvent(
              'site_click_tracking',
              trackingAction,
              trackingLabel,
              null
            );
          }
        }}
      >
        <StyledDisclaimerButton
          type="button"
          onClick={() => setShowTerms(true)}
          {...hook(disclaimerButtonHook)}
        >
          {children}
        </StyledDisclaimerButton>
      </GAClickEventTracker>
    );
  };

  DisclaimerButton.propTypes = {
    children: PropTypes.node,
  };

  const OpenExternalInNewWindow = ({ href, children }) => {
    const linkUrl = urlOrigin + href;
    return (
      <GAClickEventTracker
        onClick={() =>
          tracking.trackEvent(
            'site_navigation_clicks',
            linkUrl,
            openExternalWindowTrackingLabel,
            null
          )
        }
      >
        <PlainExternalLink href={href} {...hook(disclaimerExternalLinkHook)}>
          {children}
        </PlainExternalLink>
      </GAClickEventTracker>
    );
  };

  OpenExternalInNewWindow.propTypes = {
    href: PropTypes.string.isRequired,
    children: PropTypes.node,
  };

  return (
    <Media>
      {mq => (
        <Box>
          <small>
            <Text
              size={fontSize || (mq.lt('sm') ? 12 : 16)}
              automationHook={disclaimerHook}
            >
              <Markdown
                source={disclaimerText}
                customElements={{
                  DisclaimerButton,
                  OpenExternalInNewWindow,
                }}
              />
            </Text>
          </small>
          {popupWindowContent && (
            <Popup
              title={popupWindowTitle}
              open={showTerms}
              onRequestClose={() => setShowTerms(false)}
              automationHook={disclaimerPopupHook}
            >
              <Markdown source={popupWindowContent} />
            </Popup>
          )}
        </Box>
      )}
    </Media>
  );
};

Disclaimer.propTypes = propTypes;

export default Disclaimer;
